import { useState } from "react";

export type AddCostPayload = {
  cost_type?: string;
  quantity?: number;
  amount?: number;
  label?: string;
};

type AddCostPanelProps = {
  onSubmit: (payload: AddCostPayload) => void;
  onCancel: () => void;
  submitting?: boolean;
};

export function AddCostPanel({ onSubmit, onCancel, submitting }: AddCostPanelProps) {
  const [costType, setCostType] = useState("material");
  const [quantity, setQuantity] = useState(1);
  const [amount, setAmount] = useState("");
  const [label, setLabel] = useState("");

  return (
    <form
      className="space-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          cost_type: costType,
          quantity: Number(quantity) || 1,
          amount: Number(amount) || 0,
          label: label.trim() || undefined,
        });
      }}
    >
      <div>
        <label htmlFor="cost-type" className="block text-sm font-medium text-text">
          Type de coût
        </label>
        <select
          id="cost-type"
          value={costType}
          onChange={(e) => setCostType(e.target.value)}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
        >
          <option value="material">Matériel</option>
          <option value="labor">Main d'œuvre</option>
          <option value="other">Autre</option>
        </select>
      </div>
      <div>
        <label htmlFor="cost-quantity" className="block text-sm font-medium text-text">
          Quantité
        </label>
        <input
          id="cost-quantity"
          type="number"
          min={0}
          step={1}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value) || 0)}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
        />
      </div>
      <div>
        <label htmlFor="cost-amount" className="block text-sm font-medium text-text">
          Montant
        </label>
        <input
          id="cost-amount"
          type="number"
          min={0}
          step={0.01}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
        />
      </div>
      <div>
        <label htmlFor="cost-label" className="block text-sm font-medium text-text">
          Libellé (optionnel)
        </label>
        <input
          id="cost-label"
          type="text"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
          placeholder="Description du coût"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text hover:bg-surface-muted"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={submitting}
          className="rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-white hover:bg-accent-hover disabled:opacity-50"
        >
          {submitting ? "Envoi…" : "Enregistrer"}
        </button>
      </div>
    </form>
  );
}
